import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { ApplicationTrainingDocument } from '../model/application-training-document.model';
import { GetAllResponse } from '../model/restful-api.model';

@Injectable({
  providedIn: 'root'
})
export class GeConfidentialDocumentService {

  constructor(
    private http: HttpClient,
    private utilities: UtilitiesService
  ) { }

  getGEConfidentialDocumentPublish(): Observable<GetAllResponse<any>> {
    const url = environment.portalURL + API_URL.CONFIDENTIAL + `/publish`;
    return this.utilities.req.httpGet<GetAllResponse<ApplicationTrainingDocument>>(url);
  }
}
